import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

import { BaseLink } from "scmp-app/components/common/base-link";

export const Container = styled.div`
  color: #666666;
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 19px;

  ${props => props.theme.breakpoints.up("tablet")} {
    font-size: 14px;
    line-height: 16px;
  }
`;

export const Link = styled(BaseLink)`
  color: #666666;

  cursor: pointer;
  text-decoration-line: underline;
`;
